import bService from '@/api/base-api'
import { CONTRACT_MANAGER_URL } from '@/configs/service-url'

const list = async (agentId) => {
  const agentUrl = CONTRACT_MANAGER_URL.AGENT
  const url = `${agentUrl}/${agentId}/attachment`
  const result = await bService.get(url)

  return result
}

const uploadAttachment = async (agentId, data) => {
  const agentUrl = CONTRACT_MANAGER_URL.AGENT
  const url = `${agentUrl}/${agentId}/attachment/upload`

  const result = await bService.post(url, data)

  return result
}

const editAttachment = async (agentId, data) => {
  const agentUrl = CONTRACT_MANAGER_URL.AGENT
  const url = `${agentUrl}/${agentId}/attachment/edit`

  const result = await bService.put(url, data)

  return result
}

const downloadAttachment = async (agentId, data) => {
  const agentUrl = CONTRACT_MANAGER_URL.AGENT
  const url = `${agentUrl}/${agentId}/attachment/download`

  const result = await bService.post(url, data)

  return result
}

const removeAttachment = async (agentId, data) => {
  const agentUrl = CONTRACT_MANAGER_URL.AGENT
  const url = `${agentUrl}/${agentId}/attachment/remove`

  const result = await bService.remove(url, data)

  return result
}

export default {
  list,
  uploadAttachment,
  editAttachment,
  downloadAttachment,
  removeAttachment
}
